import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

export default function useDynamicValue({ id }) {
	let { projectId } = useParams();

	const [t, setT] = useState("");

	const dynamicText = useSelector(
		(state) => state.main?.projects?.[projectId]?.dynamicText?.[id]
	);

	useEffect(() => {
		setT(dynamicText);
	}, [dynamicText]);

	return [t];
}
